var _module_exports = "<!-- Индикатор ограниченной функции не отображается: все функции доступны полностью. -->\n";;
var path = 'app/core/components/BEFeatureIndicator/BEFeatureIndicator.html';
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, _module_exports) }]);
module.exports = path;